import { http } from '@/api/http';
import { getMissionPlannerApiUrl } from './mission-planner.paths';
import {
  CommercialFlightsTripsResponse,
  GenerateBenchmarkBody,
  GenerateMultiOrPlanBody,
  GeneratePartialPlanBody,
  GetRefuelAirportsParams,
  PartialCommercialFlightsTripsResponse,
  PartialPlanResponse,
  PlanResponse,
  RefuelAirportsResponse,
  StartSurgeonTripsGenerationBody,
  SurgeonTripsResponse,
} from './mission-planner.types';

const createBenchmarkRoute = async (body: GenerateBenchmarkBody) => {
  const res = await http.post<{ taskId: string }>(getMissionPlannerApiUrl.createBenchmark(), body);

  return res.data;
};

const createFullRoutesList = async (body: GenerateMultiOrPlanBody) => {
  const res = await http.post<{ taskId: string }>(getMissionPlannerApiUrl.generateFullPlans(), body);

  return res.data;
};

const getBenchmarkById = async (taskId: string) => {
  const res = await http.get<PlanResponse>(getMissionPlannerApiUrl.getBenchmarkById(taskId));

  return res.data;
};

const getTaskById = async (taskId: string) => {
  const res = await http.get<PlanResponse>(getMissionPlannerApiUrl.getFullPlans(taskId));

  return res.data;
};

const startSurgeonTripsGeneration = async (taskId: string, body: StartSurgeonTripsGenerationBody = {}) => {
  const res = await http.post<{ status: string }>(getMissionPlannerApiUrl.getSurgeonTripPlans(taskId), body);

  return res.data;
};

const startCommercialFlightsGeneration = async (taskId: string) => {
  const res = await http.post<{ status: string }>(getMissionPlannerApiUrl.getCommercialFlightsPlans(taskId));

  return res.data;
};

const getSurgeonTripsById = async (taskId: string) => {
  const res = await http.get<SurgeonTripsResponse>(getMissionPlannerApiUrl.getSurgeonTripPlans(taskId));

  return res.data;
};

const getCommercialFlightsById = async (taskId: string) => {
  const res = await http.get<CommercialFlightsTripsResponse>(getMissionPlannerApiUrl.getCommercialFlightsPlans(taskId));

  return res.data;
};

const getRefuelAirports = async (body: GetRefuelAirportsParams) => {
  const res = await http.post<RefuelAirportsResponse>(getMissionPlannerApiUrl.getRefuelAirports(), body);

  return res.data;
};

const generatePartialRoute = async (body: GeneratePartialPlanBody) => {
  const res = await http.post<{ taskId: string }>(getMissionPlannerApiUrl.generatePartialPlan(), body);

  return res.data;
};

const getPartialPlanById = async (taskId: string) => {
  const res = await http.get<PartialPlanResponse>(getMissionPlannerApiUrl.getPartialPlan(taskId));

  return res.data;
};

const generatePartialCommercialFlights = async (taskId: string) => {
  const res = await http.post<{ status: string }>(getMissionPlannerApiUrl.getPartialCommercialFlightsPlan(taskId));

  return res.data;
};

const getPartialCommercialFlightById = async (taskId: string) => {
  const res = await http.get<PartialCommercialFlightsTripsResponse>(
    getMissionPlannerApiUrl.getPartialCommercialFlightsPlan(taskId),
  );

  return res.data;
};

export const missionPlannerApiFetcher = {
  createBenchmarkRoute,
  createFullRoutesList,
  getBenchmarkById,
  getTaskById,
  getRefuelAirports,
  startSurgeonTripsGeneration,
  getSurgeonTripsById,
  startCommercialFlightsGeneration,
  getCommercialFlightsById,
  generatePartialRoute,
  getPartialPlanById,
  generatePartialCommercialFlights,
  getPartialCommercialFlightById,
};
